import type { Components } from '@mui/material/styles'

import type { Theme } from '../types'

export const MuiListItemText = {
	styleOverrides: { root: { margin: 0 } },
} satisfies Components<Theme>['MuiListItemText']
